import Markdown from "react-markdown"
import styled from "styled-components"

import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { TParadiseQuote } from "src/data/paradise/paradiseQuotes/paradiseQuoteTypes"
import { MBanner } from "src/ui/MBanner/MBanner"

export function ParadiseQuoteCustomerNote({
  customerNote,
}: {
  customerNote: TParadiseQuote["customer_note"]
}) {
  return (
    <div>
      <ParadiseDetailsSection title="Customer note">
        <MBanner type="neutral">
          <MarkdownWrapper>
            <Markdown>{customerNote}</Markdown>
          </MarkdownWrapper>
        </MBanner>
      </ParadiseDetailsSection>
    </div>
  )
}

const MarkdownWrapper = styled.div`
  & p:first-child {
    margin-top: 0;
  }

  & p:last-child {
    margin-bottom: 0;
  }
`
